// console.log("[rwd2] template_main.js.js - 2021-07-22");

var doplatyInputsSelector = "#form_names :input:not(:text, :hidden, textarea, :submit, #sid_typfak_0, #sid_typfak_1)"; // TAK POWINNO BYC, to nizej dla .on("change" jest nieprzewidywalne! Zbiera WSZYSTKIE input?!
var doplatyInputs = $(doplatyInputsSelector);

const getprice_domain = (local_dre) ? 'sykons.sykon.local' : 'sykons.sykon.pl';

var getPrice = {
	getprice_link: "//" + getprice_domain + "/ajax21B/json_getprice2.php",
	// doplatyInputs 	: $("#form_names :input:not(:text, :hidden, textarea, :submit)"),
	doplatyInputs: $("#form_names :input:not(:text, :hidden, textarea, :submit, #sid_typfak_0, #sid_typfak_1)"),
	priceListner: function () {
		var onChangeInputs = doplatyInputs; // POWINNO BYC //var onChangeInputs = doplatyInputsSelector; // POTEM += ZAMIAST ADD
		var selectorForRefresh = ".onchange-refresh";

		const mw_selector = "#s_busstop_1, #s_busstop_2, #s_busstop";

		if (
			(typeof mwOnChangeRefresh !== 'undefined' && mwOnChangeRefresh)
			|| $("#trasaSamolot-container").length
		) {
			selectorForRefresh += ", " + mw_selector;
		} else onChangeInputs.add($(mw_selector));

		if ($("#sid_PromotionalCode2, input.sclass_PromotionalCode").length) {
			onChangeInputs.add($("#sid_PromotionalCode2, input.sclass_PromotionalCode"));
		}

		$(document).on("change", onChangeInputs, function () {
			this.ajaxGetPrice(); // BUG - zbiera wszystkie select/inputy!!! // onChangeInputs nie powinien byc $() tylko samym stringiem ze srodka!!!
		}.bind(this));

		$(document).on("change", selectorForRefresh, function () {
			pageSubmit();
		});
	},

	getDoplatyUzytkownik: function (uczestnikDoplatyInputs, uczestnikId, result) {
		var tmp, val;

		$(uczestnikDoplatyInputs).find('input').each(function () {
			if ($(this).is(':checked')) {
				const match_checkbox_1 = /sykon\[options\]\[(\d+)\]/;
				const match_checkbox_2 = /sykon\[options\]\[([^[\]]+)\]\[(\d+)\]/;

				if ($(this).attr('name').match(match_checkbox_1)) {
					tmp = $(this).attr('name').match(match_checkbox_1)
					if (result[tmp[1]] === undefined) result[tmp[1]] = [uczestnikId];
					else result[tmp[1]].push(uczestnikId);
					//
				} else if ($(this).attr('name').match(match_checkbox_2)) {
					tmp = $(this).attr('name').match(match_checkbox_2)
					if (result[tmp[1]] === undefined) result[tmp[1]] = [uczestnikId];
					else result[tmp[1]].push(uczestnikId);
					//
				} else if ($(this).is(":radio")) {
					val = $(this).val();

					if (val != "0") {
						if (result[val] === undefined) result[val] = [uczestnikId];
						else result[val].push(uczestnikId);
					}
				}
			}
		});

		return result;
	},
	ajaxGetPrice: function () {
		that = this;
		$('.price6').html("?");

		if ($(".promotionalCode_error") && $(".promotionalCode_error").length) {
			$(".promotionalCode_error").css('display', 'none');
			$(".promotionalCode_error").html('');
			$(".promotionalCode_ok").fadeOut(10);
			$("#sid_PromotionalCode2, input.sclass_PromotionalCode").removeClass('promotionalCode_ok-input');
		}

		$('#sid_PromotionalCode2, input.sclass_PromotionalCode').removeClass('input_error');

		// Doplaty dla poszczegolnych uczestnikow
		var uczestnikDoplatyInputs = $("[id^=doplataUczesnik_]");
		var uczestnikId;
		var result = {};

		uczestnikDoplatyInputs.each(function () {
			uczestnikId = $(this).attr("id").match(/\d+/).toString();
			result = that.getDoplatyUzytkownik(this, uczestnikId, result);
		});

		// Doplaty dla rezerwacji
		$(".doplaty :checkbox, .doplaty :radio").each(function () {
			if (this.id.match(/^sykon_extraitems(.+)/)) {
				if ($(this).is(':checked')) {
					let id_doplaty = this.id.match(/^sykon_extraitems(.+)/)[1];
					result[id_doplaty] = '';
				}
			}
		});

		// Pobieranie potrzebnych danych
		dataTmp = {};

		const agentx = $("#agentx").html();
		dataTmp.agentx = agentx;

		dataTmp.md = $("#form_names").data("md");

		const adults = (extraSteps == 4 && $(".select-kombinacje-adults").length) ? $(".select-kombinacje-adults").val() : $("#form_names").data("adults");
		if (adults != '') dataTmp.adults = adults;

		let children = $("#combinations_dzieci").val();
		// if (children) children = children.replace(/\D/g,'');

		let childAges = [];

		if ($("#combinations_dzieci").length) {
			if (!(children === "0" || children === 0 || children === undefined)) {
				for (let i = 1; i <= children; i++) {
					if ($(`#child${i}_age select`).length) childAges.push($(`#child${i}_age select`).val());
				}
			}
		} else if (!children && !childAges.length) {
				// jesli nie ma wieku dzieci w samym formularzu, a sa dzieci jako uczestnicy
				children = 0;
				$('.val_Prefix input[value="Chld"]').each(function () {
						++children;
						if ($("#form_names").data(`child_age${children}`)) childAges.push($("#form_names").data(`child_age${children}`));
				});
		}

		if (
			$("#form_names").data("offertype2") == 'OM' ||
			$("#form_names").data("offertype2") == 'FW'
		) {
			// jesli OM to nie przekazyje dzieci do getprice()
			childAges = [];
		}
		
		for (let i = 0; i < childAges.length; i++) {
			if (childAges[i] !== '') {
					dataTmp[`child${i+1}`] = childAges[i];
			}
		}

		const count_ClientMW = $("select[id$='_s_busstop_1']").length;
		if (count_ClientMW) {
			if (typeof dataTmp.Parameters == 'undefined') dataTmp.Parameters = {};
			dataTmp.Parameters.ClientMW_1 = [];
			dataTmp.Parameters.ClientMW_2 = [];

			let ClientMW_1, ClientMW_2;

			for (let i = 0; i < count_ClientMW; i++) {
				ClientMW_1 = $("#paxnames_" + i + "_s_busstop_1").val()
				if (empty_mw(ClientMW_1)) ClientMW_1 = '';
				dataTmp.Parameters.ClientMW_1.push(ClientMW_1);

				ClientMW_2 = $("#paxnames_" + i + "_s_busstop_2").val()
				if (empty_mw(ClientMW_2)) ClientMW_2 = ClientMW_1;
				dataTmp.Parameters.ClientMW_2.push(ClientMW_2);
			}

		} else {
			let miejsca_wsiadania = $("#s_busstop").val();
			let miejsca_wsiadania_1 = $("#s_busstop_1").val();
			let miejsca_wsiadania_2 = $("#s_busstop_2").val();

			if (empty_mw(miejsca_wsiadania)) miejsca_wsiadania = '';

			if ($("#s_busstop_1") && $("#s_busstop_1").length && $("#s_busstop_2") && $("#s_busstop_2").length) {
				if (empty_mw(miejsca_wsiadania_1)) miejsca_wsiadania_1 = '';
				if (empty_mw(miejsca_wsiadania_2)) miejsca_wsiadania_2 = miejsca_wsiadania_1;
			} else {
				miejsca_wsiadania_1 = '';
				miejsca_wsiadania_2 = '';
			}

			if (miejsca_wsiadania != '') dataTmp.mw = miejsca_wsiadania;
			if (miejsca_wsiadania_1 != '') dataTmp.mw_1 = miejsca_wsiadania_1;
			if (miejsca_wsiadania_2 != '') dataTmp.mw_2 = miejsca_wsiadania_2;
		}

		if (['szarpie2www', 'kulweek2www', 'kulka2www'].includes($("#agentx").html())) {
			dataTmp.DatesOfBirth = '';
			if (typeof $('#sid_dataur2') == 'object' && typeof $('#sid_dataur2').attr('name') != 'undefined') {
				if ($('#sid_dataur2').val() != '')
					dataTmp.DatesOfBirth = $('#sid_dataur2').val();
			}
		}

		if (
            0 
            || agentx == 'lulubeds2www'
            || agentx == 'checker2www'
        ) {
			var date_out = $("#form_names").data("date_out");
			var date_in = $("#form_names").data("date_in");
			var tourop_hotel = $("#form_names").data("tourop_hotel");
			var roomtype = $("#form_names").data("roomtype");

			dataTmp.departure_date = date_out;
			dataTmp.departure_place = '';

			dataTmp.arrival_date = date_in;
			dataTmp.arrival_place = '';

			dataTmp.tourop_hotel = tourop_hotel;
			dataTmp.roomtype = roomtype;
		}

		if ($("input[id^='sid_PromotionalCode'").length) {
			if (typeof dataTmp.Parameters == 'undefined') dataTmp.Parameters = {};
			dataTmp.Parameters.PromotionalCode = [];

			for (ii = 0; ii < (adults); ii++) {
				dataTmp.Parameters.PromotionalCode[ii] = '';

				if (typeof $('#sid_PromotionalCode' + (ii + 2)) == 'object' && typeof $('#sid_PromotionalCode' + (ii + 2)).attr('name') != 'undefined') {
					// kod promocyjny wpisany recznie w INPUT
					if ($('#sid_PromotionalCode' + (ii + 2)).val() != '') {
						dataTmp.Parameters.PromotionalCode[ii] = $('#sid_PromotionalCode' + (ii + 2)).val();
					}
				} else if (typeof $('input[name="sykon[paxnames][' + (ii) + '][PromotionalCode]"]') == 'object' && typeof $('input[name="sykon[paxnames][' + (ii) + '][PromotionalCode]"]').attr('name') != 'undefined') {
					// kod promocyjny przekazany przez $_GET

					if ($('input[name="sykon[paxnames][' + (ii) + '][PromotionalCode]"]').val() != '') {
						dataTmp.Parameters.PromotionalCode[ii] = $('input[name="sykon[paxnames][' + (ii) + '][PromotionalCode]"]').val();
					}
				}
			}
		}

		if ($("#form_names").data("offertype2") && 
			(
				$("#form_names").data("offertype2") == 'OK' ||
				$("#form_names").data("offertype2") == 'OM' ||
				$("#form_names").data("offertype2") == 'KJ' ||
				$("#form_names").data("offertype2") == 'FW'
			)
		) {
			// tylko dla IOMS
			if (typeof dataTmp.Parameters == 'undefined') dataTmp.Parameters = {};
			
			dataTmp.Parameters.ClientNames = [];
			dataTmp.Parameters.ClientSurnames = [];
			dataTmp.Parameters.DatesOfBirth = [];

			if (['demo2www', 'indexpol2www', 'tourist2www'].includes(agentx)) {
				dataTmp.Parameters.ClientPrefixes = [];
			}

			for (ii = 0; ii < (adults); ii++) {
				dataTmp.Parameters.ClientNames[ii] = '';
				dataTmp.Parameters.ClientSurnames[ii] = '';
				dataTmp.Parameters.DatesOfBirth[ii] = '';

				if (['demo2www', 'indexpol2www', 'tourist2www'].includes(agentx)) {
					dataTmp.Parameters.ClientPrefixes[ii] = '';

					if (typeof $('#sid_prefix' + (ii + 2)) == 'object' && typeof $('#sid_prefix' + (ii + 2)).attr('name') != 'undefined') {
						if ($('#sid_prefix' + (ii + 2)).val() != '') {
							dataTmp.Parameters.ClientPrefixes[ii] = $('#sid_prefix' + (ii + 2)).val();
						}
					}
				}

				if (typeof $('#sid_imie' + (ii + 2)) == 'object' && typeof $('#sid_imie' + (ii + 2)).attr('name') != 'undefined') {
					if ($('#sid_imie' + (ii + 2)).val() != '') {
						dataTmp.Parameters.ClientNames[ii] = $('#sid_imie' + (ii + 2)).val();
					}
				}

				if (typeof $('#sid_nazwisko' + (ii + 2)) == 'object' && typeof $('#sid_nazwisko' + (ii + 2)).attr('name') != 'undefined') {
					if ($('#sid_nazwisko' + (ii + 2)).val() != '') {
						dataTmp.Parameters.ClientSurnames[ii] = $('#sid_nazwisko' + (ii + 2)).val();
					}
				}

				if (typeof $('#sid_dataur' + (ii + 2)) == 'object' && typeof $('#sid_dataur' + (ii + 2)).attr('name') != 'undefined') {
					if ($('#sid_dataur' + (ii + 2)).val() != '') {
						dataTmp.Parameters.DatesOfBirth[ii] = $('#sid_dataur' + (ii + 2)).val();
					}
				}
			}
		} else if (typeof getPriceClientsData !== 'undefined' && getPriceClientsData) {
			if (typeof dataTmp.Parameters == 'undefined') dataTmp.Parameters = {};
			dataTmp.Parameters.ClientNames = [];
			dataTmp.Parameters.ClientSurnames = [];
			dataTmp.Parameters.DatesOfBirth = [];

			if (['demo2www', 'indexpol2www', 'tourist2www'].includes(agentx)) {
				dataTmp.Parameters.ClientPrefixes = [];
			}

			let $inputIdTMP, 
				emptyDatesOfBirth = false, 
				clientsCount = parseInt(adults) + parseInt(children);
				// clientsCount = (adults && children) ? parseInt(adults) + parseInt(children) : $('.row-osoba-uczestnik').length;

			for (ii = 0; ii < (clientsCount); ii++) {
				if (['demo2www', 'indexpol2www', 'tourist2www'].includes(agentx)) {
					$inputIdTMP = $('#sid_prefix' + (ii + 2));
					dataTmp.Parameters.ClientPrefixes[ii] = (typeof $inputIdTMP == 'object' && typeof $inputIdTMP.attr('name') != 'undefined' && $inputIdTMP.val() != '') ? $inputIdTMP.val() : '';
				}

				$inputIdTMP = $('#sid_imie' + (ii + 2));
				dataTmp.Parameters.ClientNames[ii] = (typeof $inputIdTMP == 'object' && typeof $inputIdTMP.attr('name') != 'undefined' && $inputIdTMP.val() != '') ? $inputIdTMP.val() : '';

				$inputIdTMP = $('#sid_nazwisko' + (ii + 2));
				dataTmp.Parameters.ClientSurnames[ii] = (typeof $inputIdTMP == 'object' && typeof $inputIdTMP.attr('name') != 'undefined' && $inputIdTMP.val() != '') ? $inputIdTMP.val() : '';

				if (!emptyDatesOfBirth) { // daty urodzenia przeyslane tylko gdy wszystkie sa wypelnione (getPrice tego wymaga)
					$inputIdTMP = $('#sid_dataur' + (ii + 2));
					if (typeof $inputIdTMP == 'object' && typeof $inputIdTMP.attr('name') != 'undefined' && $inputIdTMP.val() != '') {
						dataTmp.Parameters.DatesOfBirth[ii] = $inputIdTMP.val()
					} else {
						emptyDatesOfBirth = true;
						dataTmp.Parameters.DatesOfBirth = [];
					}
				}
			}
		}

		dataTmp.s_params = (typeof s_params !== 'undefined') ? s_params : '';

		if (result == "0" || result === undefined) result = '';
		dataTmp.doplaty = result;

		const $lang = getQueryParam('lang');
		if ($lang) dataTmp.lang = $lang;
		else if ($('.lang.selected').length) dataTmp.lang = $('.lang.selected').attr('data-value');

		if (agentx == 'kompasincoming2www') {
			var date_out = $("#form_names").data("date_out");
			var date_in = $("#form_names").data("date_in");

			dataTmp.date_out = date_out;
			dataTmp.date_in = date_in;

			that.getprice_link = "//localhost/sykon_s/ajax21B/json_getpricePD.php";
			that.getprice_link = "//grey.turystyka.com.pl/~sykon_s/ajax21B/json_getpricePD.php";
		}

		if (local_dre) {
			dataTmpDebug = {};
			dataTmpDebug = dataTmp;
			dataTmpDebug.callback = 'that.jsonpcallback';

			d = new Date();
			$("#json_getprice2").append('<pre style="overflow: hidden">' + d.toISOString().slice(11, 19) + ', ' + that.getprice_link + '?' + $.param(dataTmpDebug) + '</pre>');
		}

		$.ajax({
			type: "GET",
			dataType: "jsonp",
			jsonp: "callback",
			data: dataTmp,
			url: that.getprice_link,
			jsonpCallback: "that.jsonpcallback"
		});
	},
	jsonpcallback: function (data) {
		this.getFullPrice(data);
	},
	getFullPrice: function (data) {
		$("#getPriceError").css('display', 'none');

		if (typeof data.error !== 'undefined') {
			return;
		}

		if (typeof data.Cost == 'undefined') {
			if (typeof data.faultactor !== 'undefined') {
				let $error;

				if (data.faultactor == "511") {
					let $promCode = $('#sid_PromotionalCode2, input.sclass_PromotionalCode').filter(function() {
						return $(this).val() !== ''; // tylko wypelnione inputy // .trim()
					});
					
					if (!$promCode.length) {
						$promCode = $('#sid_PromotionalCode2, input.sclass_PromotionalCode');
					}

					$error = $(".promotionalCode_error");

					if ($error.length) {
						let error_msg;

						if (typeof customTextPromoCodeError !== 'undefined' && customTextPromoCodeError) {
							$promCode.each(function () {
								error_msg = ($promCode.length > 1) ? 'Co najmniej jeden z kodów' : 'Kod "' + $(this).val() + '"';
								error_msg += ' jest nieważny lub nieprawidłowy';
	
								$error = $(this).parent().parent().find(".promotionalCode_error");
								$error.html(error_msg);
								$error.css('display', 'block');
							});
						} else {
							error_msg = data.detail;
							if ($('#sid_PromotionalCode2, input.sclass_PromotionalCode') > 1) {
								error_msg += ' - Problem może dotyczyć jednego lub wszystkich wpisanych kodów.';
							}
							$error.html(error_msg);
							$error.css('display', 'block');
						}
					}

					$promCode.addClass('input_error');
					
				} else if ([509, 512, 5120, 991, 992, 993].includes(data.faultactor)) {
					$error = $("#getPriceError");

					if ($error.length) {
						$("getPriceError-input").val('');
						$error.css('display', 'block');
						$error.html("Błąd! <br>" + data.detail);
					}
				}
			}

			return;

		} else {
			if (typeof customTextPromoCodeError !== 'undefined' && customTextPromoCodeError && $('#sid_PromotionalCode2, input.sclass_PromotionalCode').val() !== '') {
				// kod jest ok
				$(".promotionalCode_ok").fadeIn(10);
				$("#sid_PromotionalCode2, input.sclass_PromotionalCode").addClass('promotionalCode_ok-input');
			}
		}

		// Aktyualizacja lotnisk w "Transport"
		if (
			typeof data.Flight !== 'undefined' 
			&& data.Flight.transport !== 'undefined' 
			&& data.Flight.transport === 'SAMOLOT'
		) {
			let transp = "Samolot"

			if (
				typeof data.Flight.Departure !== 'undefined' 
				&& typeof data.Flight.Departure.Place !== 'undefined' 
				&& typeof data.Flight.Arrival !== 'undefined'
				&& typeof data.Flight.Arrival.Place !== 'undefined'
			) {
				transp += ' (' + data.Flight.Departure.Place + '-' + data.Flight.Arrival.Place + ')';
			}
			$('.mw-val').html(transp);
		}

		//
		let cost = data.Cost;
		let len = cost.length;

		table_priceTmp = $("#table_priceTmp");
		table_price2Tmp = $("#table_price2Tmp");

		$('#table_price').empty();

		let cost_Name = '';
		let cost_Currency = '';

		for (let i = 1; i < len; i++) {
			cost_Name = cost[i].Name;

			if (cost[i].UnitCurrency == 'PLZ') cost_Currency = 'PLN'; // TODO: slowik jakis?
			else if (cost[i].UnitCurrency == 'EUP') cost_Currency = 'EUR';
			else cost_Currency = cost[i].UnitCurrency;

			if (typeof calculations_showUnitPrice && calculations_showUnitPrice && cost[i].Units > 1 && cost[i].UnitPrice != 0) {
				cost_Name += " (" + cost[i].UnitPrice + " " + cost_Currency + ")";
			}

			var model = table_priceTmp.clone(true)
				.find(".cost_Name").html(cost_Name).end()
				.find(".cost_Units").html(cost[i].Units).end()
				.find(".cost_UnitPrice").html(cost[i].UnitPrice).end()
				.find(".cost_UnitCurrency").html(cost_Currency).end()
				.find(".cost_Amount").html(cost[i].Amount).end();

				if (typeof hideZeroInCalculations !== 'undefined' 
					&& hideZeroInCalculations 
					&& cost[i].Amount == 0 && cost[i].Name.indexOf('miejsca wsiadania') === -1 
					&& cost[i].Name.indexOf('miejsca wysiadania') === -1
				) {
					model.find(".cost_price-container").remove();
				}

				if (typeof calculations_hide1multiplication !== 'undefined' 
					&& calculations_hide1multiplication 
					&& cost[i].Units == 1
				) {
					model.find(".cost_multiplication").remove();
				}

			$('#table_price').append(model.html());
		}

		var model = table_price2Tmp.clone(true)
			.find(".name1").html("Razem").end()
			.find(".price6").html(cost[0].UnitPrice).end()
			.find(".price7").html(cost[0].UnitCurrency).end();

		$('#table_price2, .table_price2').html(model.html());

		if (typeof data.ExtraInfo.StalyKlient !== 'undefined') {
			if (data.ExtraInfo.StalyKlient == "1") {
				$('#sykmain .oferta .val.stKlient').css('display', 'block');
				$('#sykmain .oferta label.stKlient').css('display', 'block');
			}
			else {
				$('#sykmain .oferta .val.stKlient').css('display', 'none');
				$('#sykmain .oferta label.stKlient').css('display', 'none');
				$('#sykmain .oferta .val.stKlient input').prop("checked", false);
			}
		}
	},
	init: function () {
		if ($("#agentx").html() == 'zbojnickie2www') return false;

		this.ajaxGetPrice();
		this.priceListner();
	}
};

$(document).ready(function () {
	getPrice.init();
});

function empty_mw(mw) {
	if (mw === undefined || [null, '', "-999", -999].includes(mw)) return true;
	return false;
}